import initialState from './initialState'
import {SET_LANGUAGE} from '../actions/actionTypes'

export default function language(state = initialState.language, action) {
    let newState
	switch (action.type) {
        case SET_LANGUAGE:
        newState = action.language
		return {
			...newState
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/language.js